import { supabase } from "@/ajax/clients/supabase";
import { AuthOtpResponse } from "@supabase/supabase-js";

export const signInWithEmailLink = async ({
  email,
  shouldCreateUser = false,
}: {
  email: string;
  shouldCreateUser?: boolean;
}): Promise<AuthOtpResponse> => {
  return await supabase.auth.signInWithOtp({
    email,
    options: {
      shouldCreateUser,
    },
  });
};
